/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState, useRef } from "react";
import { Layout, Card, Table, Tag, Button, Space } from "antd";

import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";

import { getAPI } from "../../../utils/common";
import { KITCHEN_EXP_STOCK_REPORT } from "../../../constants/api";
import LS_SERVICE from "../../../utils/localStorage";
import dayjs from "dayjs";
import { PROJECT_NAME } from "../../../constants/constent";

function KitchenExpStockReport() {
  const { Content } = Layout;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [printMode, setPrintMode] = useState(false);

  const printRef = useRef();

  const { company_name } = LS_SERVICE.get("setting") || {};

  useLayoutEffect(() => {
    getAPI(
      KITCHEN_EXP_STOCK_REPORT,
      (res) => {
        if (res.status) setData(res.data);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  const getStatusTag = (status) => {
    if (status === "Expired") return <Tag color="red">Expired</Tag>;
    if (status === "Urgent") return <Tag color="volcano">Urgent</Tag>;
    if (status === "Expiring Soon")
      return <Tag color="orange">Expiring Soon</Tag>;
    return <Tag color="green">Safe</Tag>;
  };

  const columns = [
    { title: "S.No", render: (_, __, i) => i + 1 },
    { title: "Item Name", dataIndex: "item_name" },
    { title: "Current Stock", dataIndex: "current_stock" },
    {
      title: "Purchase Date",
      dataIndex: "purchase_date",
      render: (v) => (v ? dayjs(v).format("DD MMM YYYY") : "-"),
    },
    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      render: (v) => (v ? dayjs(v).format("DD MMM YYYY") : "-"),
    },
    { title: "Days Left", dataIndex: "days_left" },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => getStatusTag(status),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Expiry Stock Alert"
          extra={
            <Space>
              <Button
                type="primary"
                danger
                onClick={() => {
                  setPrintMode(true);
                  setTimeout(() => {
                    handlePrint();
                    setPrintMode(false);
                  }, 500);
                }}
              >
                Print Report
              </Button>
            </Space>
          }
        >
          <div ref={printRef}>
            {/* PRINT HEADER */}
            {printMode && (
              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <h2>{company_name || PROJECT_NAME} Expiry Stock Report</h2>
                <h3>Date: {dayjs().format("YYYY-MM-DD")}</h3>
              </div>
            )}

            <Table
              loading={loading}
              columns={columns}
              dataSource={data}
              rowKey={(record, i) => i}
              pagination={printMode ? false : { pageSize: 10 }}
            />
          </div>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default KitchenExpStockReport;
